module.exports = __webpack_public_path__ + "static/media/refreshIcon.11a5c515.svg";